// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"hamburger_hamburger__WUHyU","nav-icon":"hamburger_nav-icon__VMFeG","open":"hamburger_open__bKcuM"};